import React from "react";
import styled from "styled-components";

const BtnBlue = ({ text, click,  styles }) => {
  return <button  onClick={click} className={`${styles.btnNormal} ${styles.btnBgBlue}`}>{text}</button>;
};

export default BtnBlue;
